import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePayoutsStore = defineStore('payout', () => {
  const payouts = ref([]);
  const setPayoutsData = (value) => {
    payouts.value = Object.values(value);
  };

  return {
    payouts,
    setPayoutsData,
  };
});
